import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { Logo } from "./Logo";

const Navbar = () => {
  const { inCart, setDrawerOpen } = useCart();
  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#D4AF37]/10 bg-[#052730]/75 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <button
          data-testid="nav-cart-button"
          onClick={() => setDrawerOpen(true)}
          className="relative flex items-center gap-2 rounded-full border border-[#D4AF37]/30 px-4 py-2 text-xs font-mono-alt uppercase tracking-[0.2em] text-[#FCD34D] transition-colors duration-300 hover:bg-[#D4AF37]/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="hidden sm:inline">Cart</span>
          {inCart && (
            <span data-testid="nav-cart-count" className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#D4AF37] text-[#052730] text-[10px] font-bold flex items-center justify-center">
              1
            </span>
          )}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
